import React, { useEffect, useMemo, useState } from 'react'
import './resultCard.scss'

interface ResultCardProps {
    title: string;
    description: string;
    score: number;
    faces: Array<string>;
}

const colors = ["#7ECCC9", "#ECA785", "#ED667B"]

const ResultCard = (props: ResultCardProps) => {
    const [calculated, setCalculated] = useState<{ color: string, img: string, position: number }>({
        color: '',
        img: '',
        position: 0,
    });

    useEffect(() => {
        let index;
        let convertedPosition;
        if (props.score < 50) {
            index = 2;
            convertedPosition = props.score * 33.3 / 50;
        } else if (props.score < 80) {
            index = 1;
            convertedPosition = props.score * 66.6 / 80;
        } else {
            index = 0;
            convertedPosition = props.score * 99.9 / 100;
        }
        setCalculated({
            color: colors[index],
            img: props.faces[index],
            position: convertedPosition - 5.5,
        })
    }, [props.score])


    return (
        <div className='result-card'>
            <section className="result-card__indicator">
                <div
                    className='result-card__indicator__background'
                    style={{ backgroundColor: calculated.color }}
                >
                    <img
                        src={calculated.img}
                        className="result-card__indicator__background__image"
                        alt="Imagen resultado"
                    />
                </div>
                <div className="result-card__indicator__stoplight">
                    <div className='result-card__indicator__stoplight__container'>
                        <div className="result-card__indicator__stoplight__item result-card__indicator__stoplight__item--red"></div>
                        <div className="result-card__indicator__stoplight__item result-card__indicator__stoplight__item--yellow"></div>
                        <div className="result-card__indicator__stoplight__item result-card__indicator__stoplight__item--green"></div>
                        <div
                            className="result-card__indicator__stoplight__container__cursor"
                            style={{ left: calculated.position + '%', backgroundColor: calculated.color }}
                        ></div>
                    </div>
                </div>
            </section>
            <section className='result-card__info'>
                <h3 className='result-card__info__title'>{props.title}</h3>
                <p className='result-card__info__description'>{props.description}</p>
            </section>
        </div>
    )
}

export default ResultCard;